export { DMS_MODULE } from '../constants';
export const NAME = 'ZakazkaDelbaPP';
export const CRUMB_LABEL_KEY = 'grdZakazkapproz';

export const COL_PRIJMENI = 'PRIJMENI';
export const COL_JMENO = 'JMENO';
export const COL_OSOBNI_CIS = 'OSOBNI_CIS';
export const COL_PRACOVNIK_ID = 'PRACOVNIK_ID';
export const COL_CAS_JDN_POC = 'CAS_JDN_POC';
